import { takeLatest, select, delay } from 'redux-saga/effects';
import { setChannelWorkflowGridSelectedLayoutId, setDashboardMaxPriceByRegion, setPostAcqWorkflowGridSelectedLayoutId } from 'store/actions';
import { saveState } from 'localStorage';

export function* localStorageSaga() {
    yield takeLatest([ // List of actions that should trigger a state save
      setChannelWorkflowGridSelectedLayoutId,
      setDashboardMaxPriceByRegion,
      setPostAcqWorkflowGridSelectedLayoutId
    ], function* (action) {
      
      yield delay(1000); // Wait for any sagas/effects/etc to finish
      const state = yield select(state => state);
    
      saveState({ // Must add handling in localStorage.js for each piece of nested state
        dashboardState: {
          rentalInventory: {
            dashboardMaxPrices: state.dashboardState.rentalInventory.dashboardMaxPrices 
          },
          retailInventory: {
            dashboardMaxPrices: state.dashboardState.retailInventory.dashboardMaxPrices 
          }
        },
        channelWorkflowState: {
          channelWorkflowGridSelectedLayoutId: state.channelWorkflowState.channelWorkflowGridSelectedLayoutId
        },
        postAcqWorkflowState: {
          postAcqWorkflowGridSelectedLayoutId: state.postAcqWorkflowState.postAcqWorkflowGridSelectedLayoutId
        },
      });
    });
  }